import { createSelector } from 'reselect';

import topSelector from './topSelector';
import otherSelector from './otherSelector';
import {
  activeItemSelector,
  hasOpenedSidebarSelector,
  hasUserSelector,
  propSelector,
} from '../../../selectors';

export default createSelector(
  propSelector,
  activeItemSelector,
  hasOpenedSidebarSelector,
  hasUserSelector,
  topSelector,
  otherSelector,
  (props, activeItem, hasOpenedSidebar, hasUser, top, other) => {
    return {
      activeItem,
      hasOpenedSidebar,
      hasUser,
      navigationItems: { top, other },
      ...props,
    };
  }
);
